/* VERSA product pages: real-variant picker.
   Keeps the hidden <select name="id"> on the real variant, and syncs price, compare-at price,
   sold-out state, low-stock note, the carousel image and the ?variant= link. */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function initPicker(root) {
    if (!root || root.dataset.v35Ready) return;
    root.dataset.v35Ready = '1';

    var dataEl = $('[data-v35-variants]', root);
    var select = $('[data-v35-vselect]', root);
    if (!dataEl || !select) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var groups = $$('[data-v35-opt]', root);
    var scope = root.closest('.v35-commerce, .v-pdp, [data-v35-pdp]') || document;
    var offer = root.closest('.v35-offer, .v-buybox') || scope;
    var form = root.closest('form');

    function byId(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }

    var current = byId(select.value) || variants[0];
    var selected = current.options.slice();

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    /* Mark option values that can't be bought with the other current choices. */
    function markAvailability() {
      groups.forEach(function (g) {
        var idx = +g.dataset.v35Opt;
        $$('[data-v35-value]', g).forEach(function (btn) {
          var test = selected.slice(); test[idx] = btn.dataset.v35Value;
          var v = findVariant(test);
          btn.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function goToMedia(mediaId) {
      if (!mediaId) return;
      var car = $('[data-v35-carousel]', scope);
      if (car) {
        var slides = $$('[data-v35-slide]', car);
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].dataset.mediaId === String(mediaId)) {
            if (car._v35go) car._v35go(i);
            else { var t = $$('[data-v35-thumb]', car)[i]; if (t) t.click(); }
            return;
          }
        }
      }
      var g = $('[data-gallery]', scope); /* VacuSeal layout */
      if (g) {
        var s2 = $$('[data-slide]', g);
        for (var k = 0; k < s2.length; k++) {
          if (s2[k].dataset.mediaId === String(mediaId)) { var th = $$('[data-thumb]', g)[k]; if (th) th.click(); return; }
        }
      }
    }

    function render(v, opts) {
      opts = opts || {};
      current = v;
      select.value = v.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      groups.forEach(function (g) {
        var idx = +g.dataset.v35Opt, val = v.options[idx];
        var lab = $('[data-v35-opt-label]', g); if (lab) lab.textContent = val;
        $$('[data-v35-value]', g).forEach(function (btn) {
          var on = btn.dataset.v35Value === val;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
      markAvailability();

      /* Price */
      $$('[data-v35-price-now]', offer).forEach(function (el) { el.textContent = v.price; });
      $$('[data-v35-price-compare]', offer).forEach(function (el) { el.textContent = v.compare || ''; el.style.display = v.compare ? '' : 'none'; });
      $$('[data-v35-price-save]', offer).forEach(function (el) { el.style.display = v.compare ? '' : 'none'; });
      $$('[data-v35-sticky-price]', scope).forEach(function (el) { el.textContent = v.price; });
      $$('[data-v35-sticky-variant]', scope).forEach(function (el) { el.value = v.id; });
      $$('[data-v35-sticky-btn]', scope).forEach(function (b) { b.disabled = !v.available; });

      /* Buy buttons */
      $$('[data-v35-add]', scope).forEach(function (b) {
        b.disabled = !v.available;
        var txt = v.available ? (b.dataset.labelAdd || b.textContent) : (b.dataset.labelSold || 'Sold out');
        if (v.available && b.dataset.labelPrice === 'true') txt += ' \u2014 ' + v.price;
        b.textContent = txt;
      });

      /* Low-stock note */
      var stock = $('[data-v35-stock]', root);
      if (stock) {
        var limit = +(root.dataset.lowStock || 0);
        if (limit > 0 && v.qty !== null && v.qty > 0 && v.qty <= limit) {
          stock.textContent = (root.dataset.lowStockText || 'Only [count] left').replace('[count]', v.qty);
          stock.hidden = false;
        } else { stock.hidden = true; stock.textContent = ''; }
      }

      if (!opts.silentMedia) goToMedia(v.media);

      if (!opts.initial && root.dataset.updateUrl === 'true' && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    groups.forEach(function (g) {
      var idx = +g.dataset.v35Opt;
      $$('[data-v35-value]', g).forEach(function (btn) {
        btn.addEventListener('click', function () {
          selected[idx] = btn.dataset.v35Value;
          var v = findVariant(selected);
          if (!v) {
            /* No exact combination: keep this choice; prefer an in-stock variant that has it. */
            var fallback = null;
            for (var i = 0; i < variants.length; i++) {
              if (variants[i].options[idx] !== selected[idx]) continue;
              if (variants[i].available) { v = variants[i]; break; }
              if (!fallback) fallback = variants[i];
            }
            if (!v) v = fallback;
          }
          if (v) { selected = v.options.slice(); render(v); }
        });
      });
    });

    /* Guard: never submit a variant the shopper can't buy. */
    if (form) {
      form.addEventListener('submit', function (e) {
        var v = byId(select.value);
        if (!v || !v.available) e.preventDefault();
      });
    }

    var openedOnVariant = /[?&]variant=/.test(window.location.search);
    render(current, { silentMedia: true, initial: true });
    /* If the page was opened on a specific variant (?variant=), show its image once the carousel is ready. */
    if (openedOnVariant && current.media) {
      window.addEventListener('load', function () { goToMedia(current.media); });
    }
  }

  function initAll(root) { $$('[data-v35-vpicker]', root).forEach(initPicker); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
